export const t = { "en": { "breezeSegmentSetup": { "setupPrompt": "Help me set up audience segments for my business." } } };
export const d = [];